import React from 'react';

const SubmitIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
            <path
                d="M6 14.6663V1.33301M6 1.33301L1 6.33301M6 1.33301L11 6.33301"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SubmitIcon;
